/**
 * "Ask a question" dialog on the product page (blocks/voge-trust-list.liquid).
 * Native <dialog> + showModal(): focus stays inside, Escape closes, the page behind is inert.
 * The form is Shopify's contact form and posts normally (so Shopify's spam protection / hCaptcha
 * works); after the redirect the dialog reopens with the success or error message.
 * Prefills the motorcycle model from "My bike" (localStorage 'voge:my-bike') and the current variant.
 */
const MY_BIKE_KEY = 'voge:my-bike';

class VogeAsk extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-ask-dialog]');
    this.opener = this.querySelector('[data-ask-open]');
    if (!this.dialog || !this.opener) return;

    this.opener.addEventListener('click', () => this.open());
    this.querySelector('[data-ask-close]')?.addEventListener('click', () => this.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('close', () => this.opener?.focus());

    const form = this.dialog.querySelector('form');
    form?.addEventListener('submit', (event) => {
      const honeypot = form.querySelector('[data-ask-hp]');
      if (honeypot instanceof HTMLInputElement && honeypot.value) event.preventDefault();
    });

    const state = this.dialog.querySelector('[data-ask-state]')?.getAttribute('data-ask-state');
    if (state) {
      this.open();
      const focusTarget = this.dialog.querySelector('[data-ask-focus]');
      if (focusTarget instanceof HTMLElement) focusTarget.focus();
    }
  }

  open() {
    this.prefill();
    if (typeof this.dialog.showModal === 'function') {
      if (!this.dialog.open) this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  close() {
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
  }

  prefill() {
    const model = this.dialog.querySelector('[data-ask-model]');
    if (model instanceof HTMLInputElement && !model.value) {
      try {
        const bike = JSON.parse(localStorage.getItem(MY_BIKE_KEY) || 'null');
        if (bike && bike.title) model.value = bike.title;
      } catch (error) {
        /* storage unavailable */
      }
    }

    const variantField = this.dialog.querySelector('[data-ask-variant]');
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (variantField instanceof HTMLInputElement && idInput instanceof HTMLInputElement && idInput.value) {
      const params = new URLSearchParams(window.location.search);
      const label = document.querySelector('variant-picker input:checked, variant-picker select')
        ? Array.from(document.querySelectorAll('variant-picker input:checked, variant-picker select'))
            .map((el) => (el instanceof HTMLSelectElement ? el.value : el.getAttribute('value')))
            .filter(Boolean)
            .join(' / ')
        : '';
      const id = idInput.value || params.get('variant');
      variantField.value = label ? `${label} (${id})` : variantField.value.replace(/\(\d+\)$/, `(${id})`);
    }
  }
}

if (!customElements.get('voge-ask')) customElements.define('voge-ask', VogeAsk);
